// @flow
import React from 'react';
import { Avatar, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import { LikeIcon, CommentIcon } from 'components';

function getType(type, mobileView, size) {
  switch (type) {
    case 'post_like':
    case 'comment_like':
      return {
        color: '#0CCE6B',
        icon: <LikeIcon size={mobileView || size === 'sm' ? 1.1 : 1.6} color="colorCommonWhite" />
      };
    case 'post_comment':
      return {
        color: '#0069FF',
        icon: <CommentIcon size={mobileView || size === 'sm' ? 1.1 : 1.6} color="colorCommonWhite" />
      };
    default:
      return {
        color: '#0CCE6B',
        icon: <LikeIcon size={mobileView || size === 'sm' ? 1.1 : 1.6} color="colorCommonWhite" />
      };
  }
};

const useStyles = makeStyles(theme => ({
  avatarWrap: {
    position: 'relative'
  },
  avatar: {
    backgroundColor: props => props.user.partner_base_color,
    width: props => props.size === 'sm' ? 50 : 63,
    height: props => props.size === 'sm' ? 50 : 63,
    fontSize: 18,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      width: 50,
      height: 50,
      fontSize: 16,
    },
  },
  type: {
    position: 'absolute',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: props => props.size === 'sm' ? -4 : -6,
    right: props => props.size === 'sm' ? -7 : -11,
    width: props => props.size === 'sm' ? 24 : 30,
    height: props => props.size === 'sm' ? 24 : 30,
    backgroundColor: props => getType(props.type)['color'],
    [theme.breakpoints.down('sm')]: {
      top: '-4px',
      right: '-7px',
      width: '24px',
      height: '24px',
    },
  }
}));

const NotificationAvatar = ({ user, type, size }) => {
  const classes = useStyles({ user, type, size });
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div className={classes.avatarWrap}>
      <Avatar className={classes.avatar}>
        {`${user.first_name.charAt(0)}${user.last_name.charAt(0)}`}
      </Avatar>
      <span className={classes.type}>{getType(type, mobileView, size)['icon']}</span>
    </div>
  );
};

export default NotificationAvatar;
